import { airPLSBaseline } from 'baselines';
import { autoPeakPicking as commonAutoPeakPicking } from 'common-spectrum';
import { xyMaxClosestYPoint } from 'ml-spectra-processing';

import { references } from './references';

export function autoPeakPicking(spectrum, options = {}) {
  const { minWidth = 0.01, correctBaseline = true } = options;

  const tempSpectrum = {
    variables: {
      x: { data: spectrum.variables.x.data },
      y: { data: spectrum.variables.y.data },
    },
  };

  if (correctBaseline) {
    tempSpectrum.variables.y.data = airPLSBaseline(
      tempSpectrum.variables.y.data,
    ).correctedSpectrum;
  }

  const peaks = commonAutoPeakPicking(tempSpectrum, {
    minMaxRatio: 0.005,
    sgOptions: { windowSize: 9, polynomial: 3 },
    ...options,
  })
    .map((peak) => ({ energy: peak.x, count: peak.y, width: peak.width }))
    .filter((peak) => peak.width > minWidth);

  if (correctBaseline) {
    // we need to recalculate the real count
    for (let peak of peaks) {
      const closest = xyMaxClosestYPoint(
        { x: spectrum.variables.x.data, y: spectrum.variables.y.data },
        { target: peak.energy },
      );
      peak.energy = closest.x;
      peak.count = closest.y;
    }
  }

  appendLabels(peaks);
  return peaks;
}

function appendLabels(peaks, options = {}) {
  const { maxDifference = 0.02 } = options;
  for (let peak of peaks) {
    let closest = references[0];
    let difference = Number.POSITIVE_INFINITY;
    for (let reference of references) {
      if (Math.abs(peak.energy - reference.value) < difference) {
        difference = Math.abs(peak.energy - reference.value);
        closest = reference;
      }
    }
    if (difference < maxDifference) {
      peak.element = closest.element;
      peak.transition = closest.transition;
    }
  }
}
